export const START_LOADING = 'cms/START_LOADING';
export const STOP_LOADING = 'cms/STOP_LOADING';
export const SHOW_SPINNER = 'cms/SHOW_SPINNER';
export const HIDE_SPINNER = 'cms/HIDE_SPINNER';
export const ADD_PRISMIC_CONTENT = 'cms/ADD_PRISMIC_CONTENT';
export const ADD_BEHAVIORS = 'cms/ADD_BEHAVIORS';
export const REMOVE_BEHAVIOR = 'cms/REMOVE_BEHAVIOR';
export const REMOVE_BEHAVIORS = 'cms/REMOVE_BEHAVIORS';
export const SET_IS_MOBILE = 'cms/SET_IS_MOBILE';
export const LOAD_AVATAR = 'cms/LOAD_AVATAR';

export interface StartLoading {
  type: typeof START_LOADING;
  payload: boolean;
}

export interface StopLoading {
  type: typeof STOP_LOADING;
  payload: boolean;
}

export interface ShowSpinner {
  type: typeof SHOW_SPINNER;
  payload: boolean;
}

export interface HideSpinner {
  type: typeof HIDE_SPINNER;
  payload: boolean;
}

export interface AddPrismicContent {
  type: typeof ADD_PRISMIC_CONTENT;
  payload: { stepId: string; prismic: any };
}

export interface AddBehaviors {
  type: typeof ADD_BEHAVIORS;
  payload: { stepId: string; behaviors: any };
}

export interface RemoveBehavior {
  type: typeof REMOVE_BEHAVIOR;
  payload: { stepId: string; behaviorKey: string };
}

export interface RemoveBehaviors {
  type: typeof REMOVE_BEHAVIORS;
  payload: { stepId: string };
}

export interface SetIsMobile {
  type: typeof SET_IS_MOBILE;
  payload: boolean;
}

export interface LoadAvatar {
  type: typeof LOAD_AVATAR;
  payload: { photo: string, name: string };
}

// --- Create Union Type

export type CmsActionsTypes = StartLoading | StopLoading | ShowSpinner | HideSpinner | AddPrismicContent | AddBehaviors | RemoveBehavior | RemoveBehaviors | SetIsMobile | LoadAvatar;
